import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import { useModalStore } from "@/hooks/Modal/hooks";
import { InstantShipTaskStatus } from "@/services/api/instantShip";
import { Badge, Button } from "antd";
import moment from "moment";
import { observer } from "mobx-react-lite";
import React from "react";
import InstantShipStore from "../../store/InstantShipStore";
import TaskModal from "./TaskModal";

interface RunningStatusProps {
    shop: ShopDTO;
    instantShipStore: InstantShipStore;
}

const CHECK_TASK_INTERVAL = 30 * 1000;

const RunningStatus: React.FC<RunningStatusProps> = observer(function (props) {
    const { shop, instantShipStore } = props;
    const modalStore = useModalStore();
    const task = instantShipStore.currentTask;
    const checkingRef = React.useRef(false);

    React.useEffect(() => {
        if (shop?.type !== ShopType.DOUDIAN || !task || task.status !== InstantShipTaskStatus.RUNNING) return;

        const timer = window.setInterval(async () => {
            if (checkingRef.current) return;
            checkingRef.current = true;

            try {
                await instantShipStore.loadCurrentTask(shop.id);
            } finally {
                checkingRef.current = false;
            }
        }, CHECK_TASK_INTERVAL);

        return () => window.clearInterval(timer);
    }, [shop?.id, shop?.type, task?.id, task?.status, instantShipStore]);

    if (shop?.type !== ShopType.DOUDIAN || !task || task.status !== InstantShipTaskStatus.RUNNING) {
        return null;
    }

    return (
        <div className="instant-ship-running-status">
            <Badge status="processing" color="#52c41a" />
            <span className="instant-ship-running-text">正在极速发货...</span>
            <span className="text-gray ml10 fs14">
                开始时间：{moment(task.startTime).format("YYYY-MM-DD HH:mm:ss")}
            </span>
            <Button
                type="link"
                className="fs14 ml5"
                onClick={() =>
                    modalStore.openModal(TaskModal, {
                        shop,
                        instantShipStore,
                        taskId: task.id,
                    })
                }
            >
                查看详情
            </Button>
        </div>
    );
});

export default RunningStatus;
